export class RemoteStorageDataEntry {
    constructor() {
        this.ResourceGuid = "";
        this.Data = null;
        this.IsGlobal = false;
        this.InsertTime = new Date();
    }
}
//# sourceMappingURL=IRemoteStorageService.js.map